<h3 class="text-lg font-bold text-[#1f273b] mb-4">Trading Plans</h3>

<div class="flex flex-wrap lg:flex-nowrap lg:justify-between gap-4">
  <div class="flex flex-wrap gap-3 text-sm text-gray-600 w-full lg:w-auto">
    <span
      class="bg-gray-100 px-3 py-1 rounded-full border border-gray-300 shadow-sm"
    >
      Filing ID:
      <span class="font-semibold text-[#1f273b]">{{ tradings.filingId }}</span>
    </span>
    <span
      class="bg-gray-100 px-3 py-1 rounded-full border border-gray-300 shadow-sm"
    >
      Issuer:
      <span class="font-semibold text-[#1f273b]">
        {{ tradings.asReportedIssuer?.asReportedIssuerName }}
      </span>
    </span>
  </div>

  <div
    class="w-full lg:w-auto flex flex-wrap justify-start lg:justify-end items-center gap-2"
  >
    <a
      *ngIf="tradings?.sourceLink"
      [href]="tradings.sourceLink"
      target="_blank"
      class="text-[#002644] hover:text-[#002644] flex items-center gap-2 transition-all duration-200"
      pTooltip="View Source File"
      tooltipPosition="top"
    >
      <i class="pi pi-link text-lg"></i>
      <span class="underline hover:no-underline font-medium">View Source</span>
    </a>

    <!-- Discard -->
    <button
      *ngIf="isAllowedUser()"
      class="py-1 px-5 border border-[#d9d9d9] rounded bg-[#1f273b] text-white hover:bg-[#2a334a]"
      (click)="discardFiling(tradings)"
      pTooltip="Discard Filing"
      tooltipPosition="top"
    >
      Discard
    </button>

    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onEditClick()"
      [disabled]="!selectedPlan"
      [ngClass]="{
        'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
          selectedPlan,
        'bg-white text-gray-800 cursor-not-allowed': !selectedPlan
      }"
      pTooltip="{{ !selectedPlan ? 'Select a row to enable editing' : '' }}"
      tooltipPosition="top"
    >
      Edit
    </button>

    <!-- Delete -->
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded"
      (click)="onDeleteSelectedPlans()"
      [disabled]="
        tradingPlansIdsForDeletion.length === 0 ||
        tradings.tradingPlans?.length === 1 ||
        tradingPlansIdsForDeletion.length === tradings.tradingPlans?.length
      "
      [ngClass]="{
        'bg-[#1f273b] text-white hover:bg-[#2a334a] cursor-pointer':
          tradingPlansIdsForDeletion.length > 0 &&
          tradingPlansIdsForDeletion.length <
            (tradings.tradingPlans?.length ?? 0),
        'bg-white text-gray-800 cursor-not-allowed':
          tradingPlansIdsForDeletion.length === 0 ||
          tradingPlansIdsForDeletion.length ===
            (tradings.tradingPlans?.length ?? 0)
      }"
      pTooltip="{{
        tradingPlansIdsForDeletion.length === 0
          ? 'Select at least one row to enable deleting'
          : tradingPlansIdsForDeletion.length === tradings.tradingPlans?.length
          ? 'You cannot remove all trading plans. Please uncheck at least one.'
          : ''
      }}"
      tooltipPosition="top"
    >
      Delete
    </button>
  </div>
</div>

<p-table
  [value]="tradings.tradingPlans"
  [paginator]="false"
  [rows]="5"
  [first]="first"
  [(selection)]="selectedPlan"
  (onSelectionChange)="onSelectionChange($event)"
  dataKey="tradingPlanId"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [rowsPerPageOptions]="[5, 10, 25, 50]"
  [expandedRowKeys]="expandedRows"
  (onRowExpand)="onRowExpand($event)"
  (onRowCollapse)="onRowCollapse($event)"
  selectionMode="single"
   styleClass="fixed-table"
>
  <ng-template #header>
    <tr>
      <th></th>
      <!-- Removed checkbox header -->
      <th></th>
      <!-- Expansion toggle column -->
      <th>PLAN ID</th>
      <th >INSIDER NAME</th>
      <th>INSIDER TYPE</th>
      <th>RELATION</th>
      <th>PLAN ACTION</th>
      <th>Tag</th>
      <th>ADOPTION DATE</th>
      <th>EFFECTIVE DATE</th>
      <th>AMENDMENT DATE</th>
      <th>TERMINATION DATE</th>
      <th>EXPIRATION DATE</th>
      <th>DURATION DAYS</th>
      <th>DELETE</th>
    </tr>
  </ng-template>
  <ng-template #body let-trading let-expanded="expanded">
    <tr [pSelectableRow]="trading" [pSelectableRowDisabled]="trading.$disabled">
      <td>
        <p-tableRadioButton [value]="trading" />
      </td>
      <td>
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="trading"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="
            expandedRows[trading.tradingPlanId]
              ? 'pi pi-chevron-down'
              : 'pi pi-chevron-right'
          "
        ></button>
      </td>
      <td class="cell-ellipsis">
        {{ trading.tradingPlanId }}
      </td>
      <td class="cell-ellipsis" [pTooltip]=" trading.asReportedInsider?.asReportedReportingEntityName ||trading.asReportedInsider?.asReportedInsiderName"   tooltipPosition="top">
        {{
          trading.asReportedInsider?.asReportedReportingEntityName ||
            trading.asReportedInsider?.asReportedInsiderName
        }}
      </td>
      <td class="cell-ellipsis">
        {{ trading.asReportedInsider?.asReportedReportingEntityType }}
      </td>
      <td
        class="cell-ellipsis"
        [pTooltip]="trading.relationshipToIssuer"
        tooltipPosition="top"
      >
        {{ trading.relationshipToIssuer }}
      </td>
      <td class="cell-ellipsis" >{{ trading.planAction }}  <sup
          *ngIf="trading.modifiedFields?.modifiedPlanAction"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        ></td>
      <td class="cell-ellipsis">
        <button
          pButton
          type="button"
          icon="pi pi-tag"
          class="p-button-rounded p-button-text"
          pTooltip="Add Tags"
          tooltipPosition="top"
          (click)="writeText(trading)"
        ></button>
           <sup
            *ngIf="trading.modifiedFields?.modifiedOther"
            class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >O</sup
          >
      </td>
      <td class="cell-ellipsis">{{ trading.adoptionDate }}  <sup
          *ngIf="trading.modifiedFields?.modifiedAdoptionDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedAdoptionDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >E</sup
        ></td>
      <td class="cell-ellipsis">{{ trading.effectiveDate }}  <sup
          *ngIf="trading.modifiedFields?.modifiedEffectiveDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        ></td>
      <td class="cell-ellipsis">{{ trading.amendmentDate }}  <sup
          *ngIf="trading.modifiedFields?.modifiedAmendmentDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedAmendedDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
        >
          E
        </sup>
      </td>
      <td class="cell-ellipsis">
        {{ trading.terminationDate }}
         <sup
          *ngIf="trading.modifiedFields?.modifiedTerminationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        >
        <sup
          *ngIf="trading.isEstimatedTerminationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >E</sup
        >
      </td>
      <td class="cell-ellipsis">{{ trading.expirationDate }} <sup
          *ngIf="trading.modifiedFields?.modifiedExpirationDate"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        ></td>
      <td class="cell-ellipsis">{{ trading.durationDays }}   
        </td>
      <td>
        <p-checkbox
          [binary]="true"
          [inputId]="'deleteCheckbox-' + trading.tradingPlanId"
          (onChange)="onCheckboxChange(trading.tradingPlanId, $event.checked)"
        ></p-checkbox>
      </td>
    </tr>
  </ng-template>

  <!-- Row expansion content remains the same -->
  <ng-template pTemplate="rowexpansion" #expandedrow let-trading>
    <tr>
      <td colspan="12" class="p-0">
        <div class="p-4">
          <h4 class="text-lg font-bold mb-2">Security Breakdowns</h4>
          <p-table [value]="trading.asReportedSecurityBreakdowns">
            <ng-template #header>
              <tr>
                <th>BREAKDOWN ID</th>
                <th>PLAN ID</th>
                <th>SECURITY TYPE</th>
                <th>TRANSACTION TYPE</th>
                <th>NUMBER OF SHARES</th>
                <th>SHARES DESCRIPTION</th>
                <th>NOTIONAL VALUE</th>
              </tr>
            </ng-template>
            <ng-template #body let-security>
              <tr>
                <td>
                  {{ security?.asReportedSecurityBreakdownId }}
                </td>
                <td>
                  {{ security?.tradingPlanId }}
                </td>
                <td>
                  {{ security?.asReportedSecurity?.asReportedSecurityType }}
                </td>
                <td class="space-x-1 flex items-center whitespace-nowrap">
                  {{ security.transactionType }}
                 <sup
        *ngIf="getStringForTransactionTags(security.securityBreakdownTags)"
        class="ml-1 flex text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
      >
        {{
          getStringForTransactionTags(
            security.securityBreakdownTags
          )
        }}
      </sup>
        <sup
        *ngIf="trading.modifiedFields?.modifiedTransactionType"
        class=" text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
      >
        M
      </sup>
                </td>
                <td>{{ security.numberOfShares | number:'1.0-0'  }}  <sup
          *ngIf="trading.modifiedFields?.modifiedNumberOfShares"
          class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
          >M</sup
        ></td>
                <td  class="cell-ellipsis" [pTooltip]="security.sharesDescription" tooltipPosition="top">
                  {{ security.sharesDescription }}
                </td>
                <td>{{ security.notionalValue }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmDialog key="trading-confirm"></p-confirmDialog>
<p-confirmDialog key="discardFilingForProcessedView"></p-confirmDialog>
<p-toast></p-toast>
